// import { useAuth0 } from "@auth0/auth0-react";
import styled from "styled-components";

const Contact = () => {
//   const { isAuthenticated, user } = useAuth0();

  const Wrapper = styled.section`
    padding: 9rem 0 5rem 0;
    text-align: center;

    .container {
      margin-top: 6rem;

      .contact-form {
        max-width: 50rem;
        margin: auto;

        .contact-inputs {
          display: flex;
          flex-direction: column;
          gap: 3rem;

          input[type="submit"] {
            cursor: pointer;
            transition: all 0.2s;

            &:hover {
              background-color: ${({ theme }) => theme.colors.white};
              border: 1px solid ${({ theme }) => theme.colors.btn};
              color: ${({ theme }) => theme.colors.btn};
              transform: scale(0.9);
            }
          }
        }
      }
    }
  `;

  return (
    <Wrapper>
      <h2 className="common-heading">Contact page</h2>

      <iframe
          title = "Direction"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3508.7011005609074!2d77.0891273!3d28.428274599999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d19c504dc48df%3A0x6f917dc2dc26235!2sEdge%20Hatch%20Designer!5e0!3m2!1sen!2sin!4v1691388519700!5m2!1sen!2sin"
        width="100%"
        height="400"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"></iframe>

      <div className="container">
        <h2>Reach Out to us...</h2>
        <br/><br/><br/>
        <div className="contact-form">
          <form
            action="https://formspree.io/f/moqobbry"
            method="POST"
            className="contact-inputs">
            <input
              type="text"
              placeholder="Name"
              name="Name"
              required
              autoComplete="off"
            />

            <input
              type="email"
              name="Email"
              placeholder="Email"
              autoComplete="off"
              required
            />
            <input
                type="tel"
                name="PhoneNumber"
                placeholder="Your Contact Number (Optional)"
                autoComplete="off"
              />
            <textarea
              name="Message"
              cols="30"
              rows="10"
              required
              autoComplete="off"
              placeholder="Enter you message"></textarea>

            <input type="submit" value="send" />
          </form>
        </div>
      </div>
    </Wrapper>
  );
};

export default Contact;
